import PropTypes from 'prop-types';
import React, {
  Children,
  PureComponent,
} from 'react';

class Core extends PureComponent {
  static propTypes = {
    direction: PropTypes.oneOf(['horizontal', 'vertical']).isRequired,
    selected: PropTypes.number.isRequired,
    shadowBackground: PropTypes.string,
    willChange: PropTypes.bool,
    children: PropTypes.array,
    className: PropTypes.string,
  }

  static defaultProps = {
    shadowBackground: 'rgba(0,0,0,0.25)',
    willChange: false,
  }

  getTurn = (selected) => {
    let turn = selected % 1;
    if (turn < 0) {
      turn += 1;
    }
    if (turn >= 0.5) {
      turn -= 1;
    }
    turn *= 2;
    return turn;
  }

  getRotation = (direction, turn) => turn * (direction === 'horizontal' ? -90 : 90);

  getTransform = (direction, turn) => `rotate${direction === 'horizontal' ? 'Y' : 'X'}(${this.getRotation(direction, turn)}deg)`;

  render() {
    const {
      children,
      className,
      direction,
      selected,
      shadowBackground,
      willChange,
      ...otherProps
    } = this.props;
    const childrenArray = Children.toArray(children);
    const curr = childrenArray[Math.round(selected)];
    const prev = childrenArray[Math.round(selected) - 1];
    const next = childrenArray[Math.round(selected) + 1];
    const turn = this.getTurn(selected);
    const currStyle = {};
    const prevStyle = {};
    const prevCurrStyle = {};
    const prevShadowStyle = { background: shadowBackground };
    const nextStyle = {};
    const nextCurrStyle = {};
    const nextShadowStyle = { background: shadowBackground };
    if (turn < 0) {
      currStyle.opacity = 0;
      prevCurrStyle.transform = this.getTransform(direction, turn);
      prevShadowStyle.opacity = -turn;
      nextShadowStyle.opacity = 0;
    } else if (turn > 0) {
      currStyle.opacity = 0;
      nextCurrStyle.transform = this.getTransform(direction, turn);
      nextShadowStyle.opacity = turn;
      prevShadowStyle.opacity = 0;
    } else {
      prevStyle.visibility = 'hidden';
      prevCurrStyle.visibility = 'hidden';
      nextStyle.visibility = 'hidden';
      nextCurrStyle.visibility = 'hidden';
    }
    if (willChange) {
      currStyle.willChange = 'opacity';
      prevStyle.willChange = 'visibility';
      prevCurrStyle.willChange = 'visibility, transform';
      prevShadowStyle.willChange = 'opacity';
      nextStyle.willChange = 'visibility';
      nextCurrStyle.willChange = 'visibility, transform';
      nextShadowStyle.willChange = 'opacity';
    }
    return (
      <div className={`_1ncNYh11bEgDHaKrVgg3AR _2BXhR9UHrnlpm_nHq7-PdZ ${className}`} {...otherProps}>
        <div className="r7OsZg7yeZ9DuLfw2IEiG" style={currStyle}>{curr}</div>
        <div
          className="_1dMDT1m5zXlSxArCEZKgPw"
          style={prevStyle}
          aria-hidden="true"
        >
          <div>{prev}</div>
        </div>
        <div
          className="_1dMDT1m5zXlSxArCEZKgPw"
          style={prevCurrStyle}
          aria-hidden="true"
        >
          <div>{curr}</div>
          <div style={prevShadowStyle} />
        </div>
        <div className="_3NJbiiVgEGpfWA-RGgRm8e" style={nextStyle} aria-hidden="true">
          <div>{next}</div>
        </div>
        <div className="_3NJbiiVgEGpfWA-RGgRm8e" style={nextCurrStyle} aria-hidden="true">
          <div>{curr}</div>
          <div style={nextShadowStyle} />
        </div>
      </div>
    );
  }
}

export default Core;
